import GLOBAL from "../../../../../../setup/constants/global";

export const buttonList = [
  { key: "tenants", label: "Tenants" },
  { key: "teams", label: "Teams" },
  { key: "others", label: "Others" },
];
